import React, { PureComponent } from 'react';
import { Route } from 'react-router-dom';
import { withRouter } from 'react-router';
import { Card, CardBody, Col, Button, ButtonToolbar } from 'reactstrap';
import { Field, reduxForm } from 'redux-form';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import TimetableIcon from 'mdi-react/TimetableIcon';
import {
  WEBINARS_SUCCESS,
  WEBINARS_FAILED,
  createWebinar as createWebinarAction,
  webinarClearState as webinarClearStateAction,
} from '../../../../redux/actions/webinarsActions';
import ButtonToNavigate from '../../../../shared/components/form/ButtonToNavigate';
import renderField from '../../../../shared/components/form/TextField';
import { FullWideNotification } from '../../../../shared/components/Notification';
import renderCheckBoxField from '../../../../shared/components/form/CheckBox';
import renderDateTimePickerField from '../../../../shared/components/form/DateTimePicker';
import validate from '../../validate';

class CreateForm extends PureComponent {
  static propTypes = {
    t: PropTypes.func.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    submitting: PropTypes.bool.isRequired,
    history: PropTypes.objectOf(PropTypes.any).isRequired,
    submitStatus: PropTypes.string.isRequired,
    showNotification: PropTypes.func.isRequired,
    webinarClearState: PropTypes.func.isRequired,
  };

  componentWillReceiveProps(nextProps) {
    const { submitStatus, history } = nextProps;

    if (submitStatus === WEBINARS_SUCCESS) {
      history.push('/webinars');
    } else if (submitStatus === WEBINARS_FAILED) {
      this.show('danger', 'Произошла непредвиденная ошибка. Обратитесь к разработчикам.');
    }
  }

  componentWillUnmount() {
    const { webinarClearState } = this.props;
    webinarClearState();
  }

  show = (color, message) => {
    const { showNotification } = this.props;
    return showNotification({
      notification: <FullWideNotification color={color} message={message} />,
      position: 'full',
    });
  };

  render() {
    const { handleSubmit, submitting, t } = this.props;

    return (
      <Col md={12} lg={12}>
        <Card>
          <CardBody>
            <div className="card__title">
              <h5 className="bold-text">{t('webinars.forms.create_form_title')}</h5>
              <h5 className="subhead">{t('webinars.forms.create_form_description')}</h5>
            </div>
            <form className="form" onSubmit={handleSubmit}>
              <div className="form__form-group">
                <span className="form__form-group-label">Название вебинара</span>
                <div className="form__form-group-field">
                  <Field name="name" component={renderField} type="text" placeholder="Название вебинара" />
                </div>
              </div>
              <div className="form__form-group">
                <span className="form__form-group-label">Видео поток</span>
                <div className="form__form-group-field">
                  <Field name="stream" component={renderField} type="text" placeholder="Видео поток" />
                </div>
              </div>
              <div className="form__form-group">
                <span className="form__form-group-label">Время начала вебинара</span>
                <div className="form__form-group-field">
                  <Field name="start" component={renderDateTimePickerField} />
                  <div className="form__form-group-icon">
                    <TimetableIcon />
                  </div>
                </div>
              </div>
              <div className="form__form-group">
                <span className="form__form-group-label">Время окончания вебинара</span>
                <div className="form__form-group-field">
                  <Field name="end" component={renderDateTimePickerField} />
                  <div className="form__form-group-icon">
                    <TimetableIcon />
                  </div>
                </div>
              </div>
              <div className="form__form-group">
                <div className="form__form-group-field">
                  <Field name="isChat" component={renderCheckBoxField} label="Отключить общий чат для этого вебинара" />
                </div>
              </div>
              <ButtonToolbar className="form__button-toolbar">
                <Button color="primary" type="submit" disabled={submitting}>
                  Создать
                </Button>
                <Route path="/" render={(props) => <ButtonToNavigate {...props} title="Отмена" path="/webinars" />} />
              </ButtonToolbar>
            </form>
          </CardBody>
        </Card>
      </Col>
    );
  }
}

const mapStateToProps = (state) => ({
  submitStatus: state.webinars.submitStatus,
});

const mapDispatchToProps = (dispatch) => ({
  webinarClearState: () => dispatch(webinarClearStateAction()),
});

const CreateFormComponent = connect(mapStateToProps, mapDispatchToProps)(CreateForm);

export default reduxForm({
  form: 'webinars_create_form', // a unique identifier for this form
  validate,
  onSubmit: createWebinarAction,
})(withTranslation('common')(withRouter(CreateFormComponent)));
